import useGetTaskDetails from './useGetTaskDetails';

export default useGetTaskDetails;
export * from './useGetTaskDetails';
